import { useAlerting, useTranslation } from "src/hooks";
import { MultisigStatus } from "src/utils/constant";
import { Button, Tooltip } from "src/components/MuiGenerals";
import RetryIcon from "@mui/icons-material/Replay";
import { postRetryPrepareMultisig } from "src/api/merchant";

function MultisigStatusBlock({
  displayValue,
  rawValue,
  batchId,
  refetchFn,
}: {
  displayValue: string | number;
  rawValue: MultisigStatus;
  batchId: string;
  refetchFn: () => Promise<void>;
}) {
  const { t } = useTranslation("assetManagement");
  const { alerting } = useAlerting();

  const isPrepareFailed = rawValue === MultisigStatus.multisignPrepareFailed;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      {displayValue}
      {isPrepareFailed && (
        <Tooltip title={t("retry")}>
          <Button
            sx={{
              borderRadius: "100%",
              minHeight: 24,
              minWidth: 24,
              padding: 0,
            }}
            variant="contained"
            onClick={async () => {
              const res = await postRetryPrepareMultisig({
                batchId: batchId,
              });

              if (!res) {
                return alerting("warning", t("retry_prepare_multisig_failed"));
              }

              alerting("success", t("retry_prepare_multisig_success"));
              refetchFn();
            }}
            children={<RetryIcon fontSize="small" />}
          />
        </Tooltip>
      )}
    </div>
  );
}

export default MultisigStatusBlock;
